<template>
    <div id="HeaderBar" class="fixed-top" :style="`background-color:Black; border-bottom: solid 1px rgb(0,0,0); `">
        <QuickBar3 :username="username" :customer="customer"></QuickBar3>
        <AppSelectorBar3 :ref="asbref"></AppSelectorBar3> 
        <div class="row mb-2">
            <div class="col-md-4 mt-1">
                <div class="input-group flex-nowrap mt-1 p-1">
                    <button class="btn fs-4 bg-transparent gradient-text rounded" href="#appSelectorBar" data-bs-toggle="offcanvas" aria-controls="offcanvasExample" :disabled="loading">
                        <i class="fa-solid fa-bars mt-2"></i>
                    </button>
                    <div v-if="capp != 'home' & !loading" class="" style="width: 25%; pointer-events:none;">
                        <img :src="require(`@/assets/app/logobar.png`)" :alt="title" width="70" height="70" class="img-fluid rounded d-inline-block align-text-center" title="Kraken" :disabled="loading">
                    </div>
                    <div v-if="capp != 'home' & !loading" class="fw-light fs-1 mt-2 text-start" style="letter-spacing: 8px;" @click="moveRoute('/home')">
                        <span class="gradient-text" :class="{'fa-fade': loading}" style="cursor: pointer;">Kraken</span>
                    </div>
                </div>
            </div>
            <div v-if="!loading" class="col-md-4">
                <div v-if="capp == 'home'" class="mt-3">
                    <div class="" style="width: 10%;"></div>
                    <div class="fw-light fs-1 text-center" style="letter-spacing: 8px;" @click="moveRoute('/home')">
                        <span class="gradient-text" :class="{'fa-fade': loading}" style="cursor: pointer;">Kraken</span>
                    </div>
                </div>
                <div v-if="capp != 'home'" class="input-group flex-nowrap" :class="{'disabled-div': loading}">
                    <div v-if="showSections" style="width: 10%;"></div>
                    <div v-if="!showSections" style="width: 25%;"></div>
                    <div v-if="[null,'suite'].includes(capp)" style="width: 10%;"></div>
                    <img v-if="![null,'suite'].includes(capp)" :src="require(`@/assets/logos/${(capp.replace('-','_')).toLowerCase()}_logo.png`)" :alt="title" width="70" height="70" class="img-fluid rounded d-inline-block align-text-center mt-2">
                    <!--<img :src="require(`@/assets/logos/suite_logo.png`)" :alt="title" width="70" height="70" class="img-fluid rounded d-inline-block align-text-center mt-2"> -->
                    <button v-if="capp != null" class="btn bg-black text-info rounded" style="letter-spacing: 2px; font-size: 20px; margin-top: 15px;" title="Current App">{{capitalize(capp)}}</button>
                    <select v-if="showSections" class="btn fw-light mt-4 text-info w-50 text-start border-start border-info border-0" style="letter-spacing: 2px; font-size: 16px;" v-model="section" @change="setSection_in()">
                        <option v-for="(_section, _index) in sections" v-bind:key="_index+1" :value="_section">{{capitalize(_section)}}</option>
                    </select>
                </div>
            </div>
            <div v-if="loading" class="col-md-4">
                <div class="fw-light fs-1 text-center mt-3" style="letter-spacing: 8px;">
                    <span class="gradient-text" :class="{'fa-fade': loading}" style="cursor: pointer;">Kraken</span>
                </div>
            </div>
            <div class="col-md-2"></div>
            <div class="col-md-2">
                <div class="input-group flew-nowrap mt-4 rounded">
                    <input v-if="!loading" type="text" class="btn gradient-text btn-transparent fs-5 w-75 rounded" style="pointer-events:none;" :value="username" readonly>
                    <div v-if="loading" class="btn fs-3 gradient-text w-75">
                        <i class="fa-solid fa-arrows-rotate" :class="{'fa-spin': loading}"></i>
                    </div>
                    <button class="btn gradient-text btn-transparent fs-4 w-25 rounded" href="#quickToolsBar" data-bs-toggle="offcanvas" aria-controls="offcanvasExample" :class="{'disabled-div': loading}">
                        <i class="fa-solid fa-xl fa-user"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import QuickBar3 from '@/components/QuickBar3.vue'
import AppSelectorBar3 from '@/components/AppSelectorBar3.vue'

export default{
    name: "HeaderBar3",
    components: {
        QuickBar3,
        AppSelectorBar3
    },
    props: {
        preferred: String,
        loading: Boolean,
        showSections: Boolean
    },
    data(){
        return {
            title: 'Kraken',
            username: null,
            customer: null,
            capp: null,
            section: null,
            sections: [],
            asbref: 'asb_home' // App Selector Bar Ref
        }
    },
    methods: {
        moveRoute(routeName){
            // Protection.
            const cr = this.$route.path
            if (cr != routeName){
                this.$router.push(routeName)
            }
        },
        init(capp, username, customer, sections, apps){
            this.sections = sections
            this.apps = apps
            this.capp = capp
            this.username = username
            this.customer = customer
            try {
              if(this.sections.includes(this.preferred)){
                this.section = this.preferred
              }
              else{
                this.section = this.sections[0]
              }
              this.setSection_in()
              this.$refs[this.asbref].getApps(this.apps)
            } catch (error) {
                console.log(error)
            }
        },
        setSection_in(){
            this.$emit('setSection_in', this.section)
        },
        capitalize(_string){
            const lower = _string.toLowerCase()
            return _string.charAt(0).toUpperCase() + lower.slice(1)
        }

    },
    computed: {},
    created: function(){},
    mounted: function(){}
}
</script>

<style scoped>

    .menu-option{
        color: rgb(255, 255, 255);
        border: solid 2px Black;
        transition-duration: 0.4s;
    }
    .menu-option:hover{
        color: rgb(72,167,238);
        border-bottom: solid 2px rgb(162, 200, 250);
    }

    .gradient-text{
        background-image: linear-gradient(rgb(57, 198, 249), rgb(0, 34, 90));
        color: transparent;
        background-clip: text;
    }
    .gradient-text:hover{
        background-image: linear-gradient(rgb(0, 34, 90), rgb(57,198,249));
        color: transparent;
        background-clip: text;
    }

    .disabled-div{
        pointer-events: none;
        opacity: 0.5;
    }

</style>
